(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["size-fit-guide"] && !Shopify.designMode) return;
  try {
    class SizeFitGuide extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('.size-fit__dialog');
      this.openBtn = this.querySelector('[data-size-fit-open]');
      this.closeBtn = this.querySelector('[data-size-fit-close]');

      this.openBtn.addEventListener('click', () => this.dialog.showModal());
      this.closeBtn.addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });
    }
  }

  if (!customElements.get('size-fit-guide')) {
    customElements.define('size-fit-guide', SizeFitGuide);
  }
  } catch(e) { console.error(e); }
})();

})();
